// extracted by mini-css-extract-plugin
export default {"switch":"app-teams-TeamForm-TeamForm-module__RWinmbllS7H80G6iPSN9"};